var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeftRedIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 1340,
    viewBox: "0 0 62 1340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0153 651C13.9722 651 9.13546 653.003 5.56946 656.569C2.00345 660.135 0.00012207 664.972 0.00012207 670.015C0.00012207 675.058 2.00345 679.895 5.56946 683.461C9.13546 687.027 13.9722 689.03 19.0153 689.03V651Z",
    fill: "#DB3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0153 669.59H14.4069V665.775L7.06409 670.016L14.4069 674.256V670.444H19.0153V669.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0L19 1340",
    stroke: "black",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 1340,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeftRedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/left_red_icon.4397c54eb6f968edcb90d05a0d56d967.svg";